import { type FC, type ReactNode, useRef } from 'react';

import {
    trackSellerBrandingCopied,
    trackSellerBrandingRightClickMenu,
    type SellerBrandingTrackingTrigger,
} from '../../utils/sellerBrandingTracking.ts';

const LONG_PRESS_MS = 500;
const RIGHT_CLICK_DEBOUNCE_MS = 300;

type Props = {
    children: ReactNode;
    trackingTrigger?: SellerBrandingTrackingTrigger;
};

export const SellerBrandingTrackingText: FC<Props> = ({ children, trackingTrigger }) => {
    const longPressTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const lastRightClickTrackedAtRef = useRef(0);

    if (!trackingTrigger) {
        return <>{children}</>;
    }

    const trackRightClickMenu = (): void => {
        const now = Date.now();
        if (now - lastRightClickTrackedAtRef.current < RIGHT_CLICK_DEBOUNCE_MS) {
            return;
        }

        lastRightClickTrackedAtRef.current = now;
        trackSellerBrandingRightClickMenu(trackingTrigger);
    };

    const clearLongPressTimer = (): void => {
        if (longPressTimerRef.current) {
            clearTimeout(longPressTimerRef.current);
            longPressTimerRef.current = null;
        }
    };

    return (
        <span
            onCopy={() => {
                trackSellerBrandingCopied(trackingTrigger);
            }}
            onContextMenu={trackRightClickMenu}
            onTouchStart={() => {
                clearLongPressTimer();
                longPressTimerRef.current = setTimeout(() => {
                    trackRightClickMenu();
                }, LONG_PRESS_MS);
            }}
            onTouchEnd={clearLongPressTimer}
            onTouchMove={clearLongPressTimer}
        >
            {children}
        </span>
    );
};
